import styled from 'styled-components'

export const Wrapper = styled.div`
display: flex;
min-height: 100%;
font-size: 14px;

@media (max-width: 768px) {
    flex-direction: column;
}
`;

export const Container = styled.div`
flex-grow: 1;
padding: 3em;
@media (max-width: 768px) {
    padding: 1em;
}
`;